module.exports = __webpack_public_path__ + "img/department.c0963bdb.png";